/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import "../../css/event211020.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
// import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event20220512_impact extends Component {
  state = {};
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _goUrl = () => {
    window.open("https://shop.aniplustv.com/item/7565", "", "");
  };

  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>붕괴3rd 가정의 달 이벤트</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <map name="Map2">
              <area
                onClick={this._goUrl}
                style={{ cursor: "pointer" }}
                shape="rect"
                coords="215, 1697, 1491, 1811"
              />
            </map>

            <img src="/img/event/event220512/backimg_1.png" useMap="#Map2" />
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20220512_impact));
